<template>
  <v-dialog
    v-model="show"
    scrollable
    :overlay="true"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.EDIT_PARKING_FINE') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-form>
          <v-container>
            <v-row class="d-flex align-center">
              <!-- Paid amount -->
              <v-col cols="12" sm="12">
                <span
                  >Trahvisumma muutmisel krediteeritakse see trahv ja luuakse
                  uus uue summaga leppetrahv/arve</span
                >
                <v-col cols="12" sm="12" class="pl-0">
                  <v-btn
                    color="primary"
                    outlined
                    class="mr-2"
                    @click="paidAmount = 10"
                  >
                    10
                  </v-btn>
                  <v-btn
                    color="primary"
                    outlined
                    class="mr-2"
                    @click="paidAmount = 15"
                  >
                    15
                  </v-btn>
                  <v-btn
                    color="primary"
                    outlined
                    class="mr-2"
                    @click="paidAmount = 20"
                  >
                    20
                  </v-btn>
                  <v-btn
                    color="primary"
                    outlined
                    class="mr-2"
                    @click="paidAmount = 25"
                  >
                    25
                  </v-btn>
                  <v-btn
                    color="primary"
                    outlined
                    class="mr-2"
                    @click="paidAmount = 30"
                  >
                    30
                  </v-btn>
                  <v-btn
                    color="primary"
                    outlined
                    class="mr-2"
                    @click="paidAmount = 35"
                  >
                    35
                  </v-btn>
                </v-col>
                <v-text-field
                  v-model.number="paidAmount"
                  class="pt-4"
                  :label="`${$vuetify.lang.t('$vuetify.COST')}*`"
                  :placeholder="$vuetify.lang.t('$vuetify.COST')"
                  outlined
                  hide-details
                  append-icon="mdi-cash"
                  type="number"
                  autofocus
                ></v-text-field>
              </v-col>
              <!-- Comments -->
              <v-col cols="12" sm="12">
                <v-textarea
                  v-model="comments"
                  :label="$vuetify.lang.t('$vuetify.COMMENTS')"
                  hide-details
                  outlined
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text :disabled="paidAmount <= 0" @click="save()">
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EditParkingFineDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    parkingFine: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      paidAmount: this.parkingFine.lastAmountInCents / 100 || 0,
      comments: ''
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    ...mapGetters('app', ['loading'])
  },
  methods: {
    ...mapActions('enforcement', ['putParkingFine']),
    save() {
      this.putParkingFine({
        id: this.parkingFine.id,
        status: this.parkingFine.status,
        paidAmount: this.paidAmount,
        placeId: this.parkingFine.place.id,
        comments: this.comments
      })
      this.close()
    },
    close() {
      this.show = false
    }
  }
}
</script>
